import "../css/CenterHtml.css"
import React, { useState } from "react";
import { Flex } from "antd";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { useQuery } from "@apollo/client";
import {
  GET_FORM_SECTION_BY_SLUG,
} from "../queries";

const CenterHtml = ({page, section, lang}) => {
	const slug = `${page}-${section}-${lang}`;	
  const [sectionData, setSectionData] = useState(() => {
		const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });
	
  const { loading, error, data } = useQuery(GET_FORM_SECTION_BY_SLUG, {
		variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.htmlPersonalizado;
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });  
	
	return (
		<>
		<Flex className="CenterHtml">
			{sectionData?.htmlTitle && (
				<Flex className="CenterHtml-title">
					<Flex vertical>
						<h2
							className="h4-headline-500"
							dangerouslySetInnerHTML={{ __html: sectionData?.htmlTitle }}
						/>
					</Flex>
				</Flex>
			)}
			<Flex className="CenterHtml-box">
				<div 
					style={{
						lineHeight: '120%'
					}}
					className='b4-body-400 CenterHtml-content'
					dangerouslySetInnerHTML={{ __html: sectionData?.htmlContent }}
				/>
			</Flex>
		</Flex>
		</>
	);
};

export default CenterHtml;
